var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M22.1891 17.3664C21.9747 17.1024 21.6147 17.0048 21.2979 17.1184C20.4099 17.4368 19.4467 17.6 18.4323 17.6C13.5795 17.6 9.6323 13.6512 9.6323 8.8C9.6323 5.88 11.0739 3.1616 13.4883 1.5264C13.7619 1.3408 13.8931 1.0064 13.8195 0.6848C13.7459 0.3632 13.4819 0.12 13.1539 0.072C12.7795 0.0176 12.4067 0 12.0323 0C5.4147 0 0.0323029 5.3824 0.0323029 12C0.0323029 18.6176 5.4147 24 12.0323 24C16.2323 24 20.0531 21.8656 22.2499 18.2912C22.4275 18.0016 22.4019 17.632 22.1891 17.3664Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMoon);
export default __webpack_public_path__ + "static/media/icon-moon.a7fafd81274b323d9a62e84aa9f4e74f.svg";
export { ForwardRef as ReactComponent };